/* FeelGoodFella hero WebGL (Three.js r128, one fragment shader)
   The "Dorset summer sun" is a living disc of coffee: domain-warped noise
   swirls like crema, ringed by fine ink contour lines, with a cream highlight
   toward the light. The cursor stirs it; a click or tap sends a ripple across
   it. Above the disc, shader smoke rises and leans away from the cursor.
   Scroll shrinks and fades it so the hero melts into the marquee.

   <canvas data-fgf-hero3d data-accent="#FF751F" data-ink="#1C1A16" data-cream="#F5F0E8"></canvas>
*/
(function () {
  'use strict';
  if (typeof window.THREE === 'undefined') return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isMobile = window.matchMedia('(max-width: 989px)').matches;

  var VERT = 'varying vec2 vUv; void main(){ vUv = uv; gl_Position = vec4(position, 1.0); }';
  var FRAG = [
    'precision highp float; varying vec2 vUv;',
    'uniform vec2 uRes; uniform float uTime; uniform vec2 uMouse; uniform vec2 uMouseV; uniform float uScroll; uniform float uIntro;',
    'uniform vec3 uAccent; uniform vec3 uInk; uniform vec3 uCream; uniform vec2 uCenter; uniform float uRadius; uniform float uRipple; uniform vec2 uRippleAt; uniform float uSmoke;',
    'float hash(vec2 p){ return fract(sin(dot(p, vec2(127.1, 311.7))) * 43758.5453123); }',
    'float noise(vec2 p){ vec2 i = floor(p); vec2 f = fract(p); f = f*f*(3.0-2.0*f); return mix(mix(hash(i), hash(i+vec2(1.,0.)), f.x), mix(hash(i+vec2(0.,1.)), hash(i+vec2(1.,1.)), f.x), f.y); }',
    'float fbm(vec2 p){ float v = 0.0; float a = 0.5; mat2 m = mat2(1.6, 1.2, -1.2, 1.6); for(int i=0;i<5;i++){ v += a*noise(p); p = m*p; a *= 0.5; } return v; }',
    'void main(){',
    '  float aspect = uRes.x / uRes.y;',
    '  vec2 p = vec2((vUv.x - 0.5) * aspect, vUv.y - 0.5);',
    '  vec2 c = vec2((uCenter.x - 0.5) * aspect, uCenter.y - 0.5);',
    '  float R = max(uRadius * uIntro * (1.0 - uScroll * 0.55 * (1.0 - step(0.49, uRadius))), 0.001);',
    '  vec2 d = p - c; float r = length(d);',
    '  vec2 m = vec2((uMouse.x - 0.5) * aspect, uMouse.y - 0.5);',
    '  float md = length(p - m);',
    '  vec2 stir = uMouseV * smoothstep(0.7, 0.0, md) * 1.6;',
    '  vec2 ra = vec2((uRippleAt.x - 0.5) * aspect, uRippleAt.y - 0.5);',
    '  float rd = length(p - ra);',
    '  float ring = sin(rd * 40.0 - uRipple * 14.0) * exp(-rd * 4.0) * exp(-uRipple * 1.8) * step(0.001, uRipple);',
    '  vec2 q = d / R;',
    '  float ang = atan(q.y, q.x) + length(q) * 1.4 + uTime * 0.05;',
    '  vec2 s = vec2(cos(ang), sin(ang)) * length(q);',
    '  vec2 w1 = vec2(fbm(s * 2.2 + uTime * 0.06 + stir), fbm(s * 2.2 - uTime * 0.05 + 3.1 - stir));',
    '  vec2 w2 = vec2(fbm(s * 3.0 + w1 * 1.8 + uTime * 0.03), fbm(s * 3.0 + w1 * 1.8 + 7.2));',
    '  float v = fbm(s * 2.4 + w2 * 2.2 + ring * 0.6);',
    '  vec3 col = mix(uAccent * 0.74, uAccent, smoothstep(0.25, 0.6, v));',
    '  col = mix(col, uCream, smoothstep(0.62, 0.9, v) * 0.85);',
    '  float contour = abs(fract(v * 9.0 + ring * 2.0) - 0.5);',
    '  float lines = 1.0 - smoothstep(0.0, 0.05, contour);',
    '  col = mix(col, uInk, lines * 0.35 * smoothstep(0.35, 0.75, v));',
    '  float lit = dot(normalize(d + 1e-4), normalize(vec2(-0.6, 0.8)));',
    '  col += uCream * 0.12 * smoothstep(0.0, 1.0, lit) * (1.0 - r / R);',
    '  col *= 1.0 - 0.18 * smoothstep(0.55, 1.0, r / R) * (1.0 - lit);',
    '  float edge = 0.003;',
    '  float disc = 1.0 - smoothstep(R - edge, R + edge, r);',
    '  float rim = clamp((1.0 - smoothstep(R - 0.004, R, r)) - (1.0 - smoothstep(R - 0.012, R - 0.008, r)), 0.0, 1.0);',
    '  col = mix(col, uInk, rim * 0.5);',
    '  vec2 su = vec2((p.x - c.x) / (R * 1.6) + 0.5, (p.y - (c.y + R * 0.6)) / (R * 2.2));',
    '  float sway = sin(su.y * 5.0 + uTime * 0.8) * 0.08 * su.y + (0.5 - uMouse.x) * 0.5 * su.y * su.y;',
    '  vec2 sq = vec2(su.x + sway, su.y);',
    '  float n1 = fbm(vec2(sq.x * 3.0, sq.y * 2.0 - uTime * 0.32));',
    '  float n2 = fbm(vec2(sq.x * 6.0 + 4.0, sq.y * 4.0 - uTime * 0.55));',
    '  float wisp = smoothstep(0.1 + su.y * 0.14, 0.0, abs(sq.x - 0.5 + (n1 - 0.5) * 0.4 * su.y));',
    '  float body = smoothstep(0.38, 0.75, n1 * 0.7 + n2 * 0.5);',
    '  float sfade = smoothstep(0.0, 0.15, su.y) * (1.0 - smoothstep(0.35, 0.85, su.y)) * step(0.0, su.y) * step(su.y, 1.0);',
    '  float topFade = smoothstep(1.0, 0.78, vUv.y);',
    '  float smoke = wisp * body * sfade * topFade * uIntro * clamp(1.0 - uScroll * 1.3, 0.0, 1.0) * (1.0 - disc) * uSmoke;',
    '  float alpha = max(disc * clamp(1.0 - uScroll * 0.9 * (1.0 - step(0.49, uRadius)), 0.0, 1.0), smoke * 0.35);',
    '  vec3 outc = mix(vec3(1.0), col, disc);',
    '  outc += (hash(gl_FragCoord.xy + uTime * 30.0) - 0.5) * 0.06 * disc;',
    '  gl_FragColor = vec4(outc, alpha);',
    '}'
  ].join('\n');

  function v3(h) { var c = new THREE.Color(h); return new THREE.Vector3(c.r, c.g, c.b); }

  function mount(canvas) {
    if (canvas.dataset.mounted) return; canvas.dataset.mounted = '1';
    var renderer;
    try { renderer = new THREE.WebGLRenderer({ canvas: canvas, antialias: false, alpha: true, premultipliedAlpha: false, powerPreference: 'high-performance' }); }
    catch (e) { canvas.style.display = 'none'; return; }
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, isMobile ? 1.5 : 2));
    renderer.setClearColor(0x000000, 0);
    var host = canvas.parentElement;
    var u = {
      uRes: { value: new THREE.Vector2(1, 1) }, uTime: { value: 0 },
      uMouse: { value: new THREE.Vector2(0.5, 0.5) }, uMouseV: { value: new THREE.Vector2(0, 0) },
      uScroll: { value: 0 }, uIntro: { value: reduce ? 1 : 0 },
      uAccent: { value: v3(canvas.dataset.accent || '#FF751F') }, uInk: { value: v3(canvas.dataset.ink || '#1C1A16') }, uCream: { value: v3(canvas.dataset.cream || '#F5F0E8') },
      uCenter: { value: new THREE.Vector2(parseFloat(canvas.dataset.cx || (isMobile ? 0.6 : 0.66)), parseFloat(canvas.dataset.cy || (isMobile ? 0.56 : 0.52))) },
      uRadius: { value: parseFloat(canvas.dataset.r || (isMobile ? 0.19 : 0.3)) },
      uSmoke: { value: canvas.dataset.nosmoke ? 0 : 1 },
      uRipple: { value: 0 }, uRippleAt: { value: new THREE.Vector2(0.5, 0.5) }
    };
    var scene = new THREE.Scene(), cam = new THREE.OrthographicCamera(-1, 1, 1, -1, 0, 1);
    scene.add(new THREE.Mesh(new THREE.PlaneGeometry(2, 2), new THREE.ShaderMaterial({ vertexShader: VERT, fragmentShader: FRAG, uniforms: u, transparent: true, depthWrite: false })));

    function resize() { var w = host.clientWidth, h = host.clientHeight; renderer.setSize(w, h, false); u.uRes.value.set(w, h); }
    resize(); window.addEventListener('resize', resize);

    var target = new THREE.Vector2(0.5, 0.5), last = new THREE.Vector2(0.5, 0.5), vel = new THREE.Vector2();
    function point(x, y) { var r = host.getBoundingClientRect(); target.set((x - r.left) / r.width, 1 - (y - r.top) / r.height); }
    host.addEventListener('mousemove', function (e) { point(e.clientX, e.clientY); });
    host.addEventListener('touchmove', function (e) { point(e.touches[0].clientX, e.touches[0].clientY); }, { passive: true });
    function ripple(x, y) { point(x, y); u.uRippleAt.value.copy(target); u.uRipple.value = 0.001; if (window.gsap) gsap.to(u.uRipple, { value: 3, duration: 2.2, ease: 'power2.out', overwrite: true }); }
    host.addEventListener('click', function (e) { ripple(e.clientX, e.clientY); });
    host.addEventListener('touchstart', function (e) { ripple(e.touches[0].clientX, e.touches[0].clientY); }, { passive: true });
    if (isMobile && window.DeviceOrientationEvent) {
      window.addEventListener('deviceorientation', function (e) {
        if (e.gamma == null) return;
        target.set(0.5 + Math.max(-1, Math.min(1, e.gamma / 30)) * 0.4, 0.5 + Math.max(-1, Math.min(1, (e.beta - 45) / 30)) * 0.3);
      }, { passive: true });
    }

    if (!reduce && window.gsap) gsap.to(u.uIntro, { value: 1, duration: 2.0, ease: 'expo.out', delay: 0.3 });
    else u.uIntro.value = 1;

    var visible = true;
    if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { visible = en[0].isIntersecting; }).observe(host);

    var start = performance.now();
    (function frame(now) {
      requestAnimationFrame(frame);
      if (!visible) return;
      u.uTime.value = (now - start) / 1000;
      u.uMouse.value.lerp(target, 0.07);
      vel.subVectors(u.uMouse.value, last); last.copy(u.uMouse.value);
      u.uMouseV.value.lerp(vel.multiplyScalar(8), 0.1);
      var r = host.getBoundingClientRect();
      u.uScroll.value = Math.min(Math.max(-r.top / r.height, 0), 1);
      renderer.render(scene, cam);
    })(start);
  }

  function init() { document.querySelectorAll('canvas[data-fgf-hero3d]').forEach(mount); }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', function (e) { e.target.querySelectorAll('canvas[data-fgf-hero3d]').forEach(mount); });
})();
